import { api } from './client';
import type { TaxRateDto, CreateTaxRateRequest, UpdateTaxRateRequest } from '../types/taxRate';

export const taxRatesApi = {
  list: () =>
    api.get<TaxRateDto[]>('/tax-rates'),

  getById: (id: number) =>
    api.get<TaxRateDto>(`/tax-rates/${id}`),

  create: (data: CreateTaxRateRequest) =>
    api.post<number>('/tax-rates', data),

  update: (id: number, data: UpdateTaxRateRequest) =>
    api.put<void>(`/tax-rates/${id}`, data),

  delete: (id: number) =>
    api.delete<void>(`/tax-rates/${id}`),
};
